

export const CUSTOM_FORMATS = {
    "date": /^\d{4}-([0]\d|1[0-2])-([0-2]\d|3[01])$/,
    "time": /[0-2][0-9]:[0-5][0-9]/
};